﻿document.addEventListener('DOMContentLoaded', () => {
  function scheduleIdle(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 0);
    }
  }

  /////////////// According Smooth Toggle Animation //////////////
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        const isOpen = this.el.open;
        const elHeight = this.el.offsetHeight;
        const summaryHeight = this.summary.offsetHeight;

        if (this.isClosing || !isOpen) {
          this.beginOpen(elHeight);
        } else if (this.isExpanding || isOpen) {
          this.beginShrink(elHeight, summaryHeight);
        }
      });
    }

    beginShrink(startPx, summaryPx) {
      this.isClosing = true;

      if (this.animation) {
        this.animation.cancel();
      }

      const startHeight = `${startPx}px`;
      const endHeight = `${summaryPx}px`;

      this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    beginOpen(closedHeightPx) {
      this.el.style.height = `${closedHeightPx}px`;
      this.el.open = true;
      requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      const startPx = this.el.offsetHeight;
      const summaryPx = this.summary.offsetHeight;
      const contentPx = this.content
        ? Math.max(this.content.offsetHeight, this.content.scrollHeight)
        : 0;
      const startHeight = `${startPx}px`;
      const endHeight = `${summaryPx + contentPx}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = '';
      this.el.style.overflow = '';
    }
  }

  scheduleIdle(function () {
    document.querySelectorAll('.accordion.smooth details').forEach((el) => {
      new Accordion(el);
    });
  });

  /////////////// Close Existing Accordion //////////////
  class AccordionToggle {
    constructor(el, accordionGroup) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.accordionGroup = accordionGroup;

      this.updateAriaExpanded(this.el.open);

      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      this.accordionGroup.closeAllExcept(this);
      requestAnimationFrame(() => {
        const isOpen = this.el.open;
        const elHeight = this.el.offsetHeight;
        const summaryHeight = this.summary.offsetHeight;

        if (this.isClosing || !isOpen) {
          this.beginOpen(elHeight);
        } else if (this.isExpanding || isOpen) {
          this.beginShrink(elHeight, summaryHeight);
        }
      });
    }

    beginShrink(startPx, summaryPx) {
      this.isClosing = true;

      if (this.animation) {
        this.animation.cancel();
      }

      const startHeight = `${startPx}px`;
      const endHeight = `${summaryPx}px`;

      this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    beginOpen(closedHeightPx) {
      this.el.style.height = `${closedHeightPx}px`;
      this.el.open = true;

      this.accordionGroup.currentAccordion = this;

      requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      const startPx = this.el.offsetHeight;
      const summaryPx = this.summary.offsetHeight;
      const contentPx = this.content ? Math.max(this.content.offsetHeight, this.content.scrollHeight) : 0;
      const startHeight = `${startPx}px`;
      const endHeight = `${summaryPx + contentPx}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = '';
      this.el.style.overflow = '';

      this.updateAriaExpanded(open);

      if (!open) {
        this.accordionGroup.currentAccordion = null;
      }
    }

    updateAriaExpanded(isExpanded) {
      this.summary.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    close() {
      if (!this.el.open) return;
      this.el.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        const startPx = this.el.offsetHeight;
        const summaryPx = this.summary.offsetHeight;
        this.beginShrink(startPx, summaryPx);
      });
    }
  }

  class AccordionGroup {
    constructor() {
      this.currentAccordion = null;
      this.accordions = [];
    }

    init() {
      document.querySelectorAll('.accordion.smooth:not(.smooth-v2) details').forEach((el) => {
        const accordion = new AccordionToggle(el, this);
        this.accordions.push(accordion);
      });
    }

    closeAllExcept(currentAccordion) {
      this.accordions.forEach((accordion) => {
        if (accordion !== currentAccordion) {
          accordion.close();
        }
      });
    }
  }

  scheduleIdle(function () {
    const accordionGroup = new AccordionGroup();
    accordionGroup.init();
  });

  scheduleIdle(function () {
    /////////////// Smooth Scroll to Anchor //////////////
    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;
        requestAnimationFrame(() => {
          const rect = targetElement.getBoundingClientRect();
          window.scrollTo({
            top: rect.top + window.pageYOffset,
            behavior: 'smooth',
          });
        });
      });
    });
  });
});
